import { LaboratoryHttpHeaderModel } from 'app/core/services/prothesis-api/laboratory-http-header-model';
import { StorageBannerModel } from './storage-banner-model';

export class StorageBannerModelHelper {
  public static fromHttpHeader(laboratoryHttpHeader: LaboratoryHttpHeaderModel): StorageBannerModel {
    const storageBanner = new StorageBannerModel();
    storageBanner.storageCapacityLimit = laboratoryHttpHeader?.storageCapacityLimit;
    storageBanner.storageUsage = laboratoryHttpHeader?.storageUsage;
    if (laboratoryHttpHeader?.storageCapacityLimit) {
      storageBanner.storageUsagePercentage = (storageBanner.storageUsage! / storageBanner.storageCapacityLimit!) * 100;
    } else {
      storageBanner.storageUsagePercentage = 0;
    }
    storageBanner.displayFlag = storageBanner.storageUsagePercentage >= 90;
    return storageBanner;
  }
}
